import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../helpers/axios";
import { toast } from "react-toastify";
import { routes } from "../../constants";

// Create Category
export const createCategory = createAsyncThunk(
  "createCategory",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.post(
        `/onecity-restaurant/category`,
        data.data,
        authHeaders()
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(data.toast, {
          autoClose: 3000,
        });
        data.navigate(`${routes.category}`);
        return response.data;
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      // console.log("error", error.response);
    }
  }
);

// Update Category
export const updateCategory = createAsyncThunk(
  "updateCategory",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.put(
        `/onecity-restaurant/category/${data.id}`,
        data.data,
        authHeaders()
      );
      if (response.status === 200 && !data.cb) {
        toast.success(data.toast, {
          autoClose: 3000,
        });
        data.navigate(`${routes.category}/page/1`);
        return response.data;
      }
      if (data.cb) {
        return data.cb(null, response.data);
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      // console.log("error:", error.response);
    }
  }
);

export const getCategory = createAsyncThunk(
  "getCategory",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.get(
        `/onecity-restaurant/category?start=${data.start || 0}&limit=${
          data.limit || 10
        }`,
        authHeaders()
      );
      return { data: response.data, count: response.headers["x-total-count"] };
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      return error.response.data.message;
    }
  }
);

const initialState = {
  categoryList: [],
  createCategory: "",
  updateCategory: "",
  loader: false,
  error: "",
  user: "",
};
const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    //get category
    builder.addCase(getCategory.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getCategory.fulfilled, (state, action) => {
      state.loader = false;
      state.categoryList = action.payload;
    });
    builder.addCase(getCategory.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    //create category
    builder.addCase(createCategory.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(createCategory.fulfilled, (state, action) => {
      state.loader = false;
      state.createCategory = action.payload;
    });
    builder.addCase(createCategory.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    //update category
    builder.addCase(updateCategory.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateCategory.fulfilled, (state, action) => {
      state.loader = false;
      state.updateCategory = action.payload;
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });
  },
});
export default categorySlice.reducer;
